import React, { useState, useMemo } from 'react';
import moment from 'moment';
import { DateRange } from '@components/atoms';
import { FilterDateRangeNoMarginStyle } from '@components/organisms/Table/Filters/styles';
import { StyledFilterWrapper } from './styles';

interface Props<T = any> {
  minDate?: Date;
  maxDate?: Date;
  dateRangeSet: any;
  setSearchConditions: React.Dispatch<React.SetStateAction<T>>;
}

const StatisticsFilter = ({ minDate, maxDate, dateRangeSet, setSearchConditions }: Props) => {
  return (
    <StyledFilterWrapper>
      <DateRange
        border
        isTabVisible={false}
        dateRangeSet={dateRangeSet}
        placeholder={'Select range'}
        minDate={minDate}
        maxDate={maxDate}
        styles={FilterDateRangeNoMarginStyle}
        setDateRangeSet={setSearchConditions}
      />
    </StyledFilterWrapper>
  );
};

export default StatisticsFilter;
